import { z } from "zod";
/**
 * Factory function to create CreateInvitationValidator with translations
 */
export const createCreateInvitationValidator = (t) => z.object({
    email: z.email(t("validation.email")),
    accountIds: z
        .array(z.number().int().positive())
        .min(1, t("validation.invitations.atLeastOneAccountRequired")),
    role: z.enum(["owner", "admin", "member"]).default("member"),
});
/**
 * Factory function to create AcceptInvitationValidator with translations
 */
export const createAcceptInvitationValidator = (t) => z.object({
    token: z.string().min(1, t("validation.invitations.tokenRequired")),
});
/**
 * Factory function to create ResendInvitationValidator with translations
 */
export const createResendInvitationValidator = (_t) => z.object({
    invitationId: z.number().int().positive(),
});
